import { Checkbox as CheckboxRoot } from "./Checkbox";

export const Checkbox = CheckboxRoot;
